import { DynamicTab, NewDynamicTab } from "../../../components/Page";
import { GridcoDiscomAnalysis } from "./Discom_Analysis";
import { GridcoTrend } from "./TrendAnalysis";
import { GridcoTitle } from "../components";
import GridcoMeter from "./Meter";
import GridcoMeterTrend from "./Meter_Trend";
import { GridcoPowerDemandDefaultDates } from "../../../config/DefaultDates";
import { TabSwitcher } from "../Gridco_Das";

export function GridcoDemand() {
  return (
    <>
      <NewDynamicTab
        defaultDates={GridcoPowerDemandDefaultDates}
        header="Demand"
        trendTabs={["Trend Analysis", "Sub Station with OA Trend Analysis"]}
        headerPrefixComponent={<TabSwitcher />}
        middleComponent={<GridcoTitle />}
        tabs={{
          "Discom Load": <GridcoDiscomAnalysis />,
          "Trend Analysis": <GridcoTrend />,
          "Sub Station with OA": <GridcoMeter />,
          "Sub Station with OA Trend Analysis": <GridcoMeterTrend />,
        }}
        disabledTabs={["Sub Station with OA","Sub Station with OA Trend Analysis"]}
      />
    </>
  );
}
